import classnames from 'classnames';
import type { FC } from 'react';
import { Children } from 'react';
import styled from 'styled-components';

const Group = styled.div`
  display: inline-flex;
  border-radius: 2em;
  background: var(--c-nd-100);
  border: 2px solid var(--c-nd-200);
  height: var(--quadruple-unit);
  color: var(--c-white);
  > button {
    padding: 0 var(--double-unit);
    min-width: min-content;
    opacity: 0.5;
    &:first-child {
      border-top-left-radius: inherit;
      border-bottom-left-radius: inherit;
    }
    &:last-child {
      border-top-right-radius: inherit;
      border-bottom-right-radius: inherit;
    }
    > * {
      display: block;
    }
    &.active {
      opacity: 1;
      background: var(--c-nd-100);
    }
    &:hover,
    &:focus {
      opacity: 1;
      background: var(--c-nd-50);
    }
  }
`;

type Props = {
  value?: number;
  onChange: (index: number) => void;
};

export const ButtonGroup: FC<React.PropsWithChildren<Props>> = ({
  children,
  value,
  onChange,
}) => {
  return (
    <Group>
      {Children.map(children, (child, i) => (
        <button
          type="button"
          // oxlint-disable-next-line react/no-array-index-key
          key={`buttonGroup_button_${i}`}
          onClick={() => onChange(i)}
          className={classnames({ active: value === i })}
        >
          {child}
        </button>
      ))}
    </Group>
  );
};
